import { z, ZodType } from 'zod';

export function requiredInput<TSchema extends ZodType>(schema: TSchema) {
  return schema.nullable().transform((value, ctx) => {
    if (value === null) {
      ctx.addIssue({
        code: 'invalid_type',
        expected: schema._zod.def.type,
        input: null,
      });
      return z.NEVER;
    }
    return value;
  });
}
